GoogleApiService.$inject = [
    '$q',
    '$http',
    '$sce',
    '$log',
    'UtilService',
    'GetFetchService',
];
function GoogleApiService(
    $q,
    $http,
    $sce,
    $log,
    UtilService,
    GetFetchService
) {
    const apiKey = UtilService.getSetting('googleApiKey');
    const autocompleteService = new google.maps.places.AutocompleteService();

    return {
        addressAutocomplete,
        getInfoFromAddress,
        getInfoFromZipcode
    };

    /**
     * Takes a partial address and queries google autocomplete for a list of 5 matching
     * addresses.
     * @param address
     */
    function addressAutocomplete(address) {
        const deferred = $q.defer();

        const params = {
            input: address,
            key: apiKey
        };

        autocompleteService.getPlacePredictions(params, function (predictions, status){
            if (status === 'OK') {
                deferred.resolve(predictions);
            } else {
                deferred.reject(predictions);
            }
        });

        return deferred.promise;
    }

    /**
     * Returns the formatted address json based on the given google maps components object.
     *
     * @param components: google maps components object
     * @returns {{country: (string|string), city: (Document.form.city|string|string),
     *          address_line_1: *, address_line_2: string, state: *, postal_code: (Document.form.postal_code|string)}}
     */
    function getAddressFromComponents(components) {
        const addressComponentsObject = {};
        components.forEach(function(component){
            let key = component.types[0];
            if (key === 'locality') {
                key = 'city';
            } else if (key ==='administrative_area_level_1'){
                key = 'state';
            }  else if (key ==='administrative_area_level_2'){
                key = 'county';
            }
            addressComponentsObject[key] = component.short_name;
        });
        return {
            address_line_1: '{} {}'.format(addressComponentsObject.street_number, addressComponentsObject.route),
            address_line_2: '',
            city: addressComponentsObject.city,
            state: addressComponentsObject.state,
            postal_code: addressComponentsObject.postal_code,
            country: addressComponentsObject.country
        };
    }

    /**
     * Obtains user's coordinates from the given address
      *
     * @param address {string}
     * @returns {Promise}
     */
    function getInfoFromAddress(address) {
        let deferred = $q.defer();
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({address: address}, (results, status) => {
            if (status === 'OK' && results.length > 0) {
                const location = results[0].geometry.location;
                deferred.resolve({
                    latLng: {
                        lat: location.lat(),
                        lng: location.lng()
                    },
                    components: getAddressFromComponents(results[0].address_components)
                });
            } else {
                $log.error(`Geocode was not successful for the following reason: ${status}`);
                deferred.reject({});
            }
        });
        return deferred.promise;
    }

     /**
     * Obtains user's coordinates from user's zipcode
      *
     * @param zipCode  {string}
     * @returns {Promise}
     */
    function getInfoFromZipcode(zipCode) {
        let deferred = $q.defer();
        const cachePath = `zipcode-coordinates-${zipCode}`;
        const cachedCoordinates = GetFetchService.getRaw(cachePath);
        if (cachedCoordinates) {
            deferred.resolve(cachedCoordinates)
        } else {
            getInfoFromAddress(zipCode).then((data) => {
                GetFetchService.update(cachePath, data.latLng);
                deferred.resolve(data.latLng)
            });
        }

        return deferred.promise;
    }

}

module.exports = GoogleApiService;